import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["readMore"];

    connect() {
        if (this.hasReadMoreTarget) {
            this.readMoreTarget.classList.remove("hide");

            const elements = this.element.querySelectorAll(".rich-text");

            for (let i = 0; i < elements.length; i++) {
                if (i > 0) {
                    elements[i].classList.add("hide");
                }
            }
        }
    }

    readMore() {
        if (this.hasReadMoreTarget) {
            this.readMoreTarget.classList.add("hide");

            const elements = this.element.querySelectorAll(".rich-text.hide");

            for (let hidden of elements) {
                hidden.classList.remove("hide");
            }
        }
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/more_controller.js